import { axiosPreview, axiosFile, axiosDevelopment, axiosBase } from './config';

export const AWSService = {
    CREATE_SNAPSHOT(data) {
        return axiosDevelopment.post(`ajax/multimedia-snapshot`, data, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
            }
        });
    },
    CONVERT(convertURL, key, userID, title) {
        return axiosPreview.post(`${convertURL}classes/convert.php?k=${key}&uid=${userID}&t=normal&nm=${title}`);
    },
    UPLOAD_STATUS(userID, sessionID) {
        return axiosBase.get(`f2020_video_encode_status?u=${userID}&sn=${sessionID}`);
    },
    AWS_ACCESS() {
        return axiosPreview.get(`classes/vid_upload_form_data.php`);
    },
    POST_FILE(data, config) {
        return axiosFile.post(``, data, config);
    },
};